import React, { useEffect, useState } from "react";
import { IoIosPaper } from "react-icons/io";
import moment from "moment";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import TextInput from "../../../components/common/TextInput/TextInput";
import CustomDatePicker from "../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../components/common/Table/CustomTable";
import PreviewImage from "../../../components/common/PreviewImage/PreviewImage";
import RejectDialog from "../../../components/common/RejectDialog/RejectDialog";
import SwalToast from "../../../components/helpers/SwalToast";
import { convertLoanNonCash } from "../helpers/convertLoanNonCash";
import { initFilterInput, renderLoanNonCashColumns } from "../constants";
import "../styles.css";

const LoanNonCash = () => {
  const history = useHistory();
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [searchNameValue, setSearchNameValue] = useState("");
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [dateValue, setDateValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [imgLink, setImgLink] = useState("");
  const [selectedID, setSelectedID] = useState("");
  const [errors, setErrors] = useState({});
  const [reason, setReason] = useState("");
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [loanNonCashList, setLoanNonCashList] = useState([]);

  const getLoanNonCash = () => {
    setLoading(true);
    const data = {
      search: filterInput.searchName,
      start_date: filterInput.transactionStartDate,
      end_date: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/waiting-transfer`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data
      ),
      (response) => {
        setLoading(false);
        setTotalTransactions(response.data.data.total_item);
        setLoanNonCashList(
          convertLoanNonCash(response.data.data.items, handleOpenPreview)
        );
        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        console.log(error)
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setPageSizeValue(value);
    } else if (name === "searchName") {
      setSearchNameValue(value);
    } else if (name === "reason") {
      setReason(value);
    }
  };

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { name, value } = event.target;
        if (event.keyCode === 13 || type === "blur") {
          if (value === "" && name === "pageSize") {
            setPageSizeValue(10);
          }
          setFilterInput((prev) => ({
            ...prev,
            [name]: value === "" && name === "pageSize" ? 10 : value,
            page: 1,
          }));
        }
      };

  const handleProcessButtonClick = (loanData) => {
    history.push({
      pathname: `/loan-noncash/${loanData.gadaiID}`,
      state: {
        data: loanData.processLoanDetail,
      },
    });
  };

  const handleRejectButtonClick = (gadaiID) => {
    setSelectedID(gadaiID);
    setIsRejectDialogOpen(true);
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const validateReject = () => {
    const newErrors = {};

    if (!reason || reason === "") {
      newErrors.reason = "Alasan tidak boleh kosong";
    }
    return newErrors;
  };

  const handleRejectSave = () => {
    const newErrors = validateReject();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      const data = {
        notes: reason,
      };

      let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${selectedID}/disburse-cancel`;
      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Sukses Membatalkan Proses Pinjaman",
          });
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal Membatalkan Proses Pinjaman: ${error?.response?.data?.error?.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setIsRejectDialogOpen(false);
          setReason("");
          getLoanNonCash();
        }
      );
    }
  };

  const handleCancel = () => {
    setIsRejectDialogOpen(false);

    if (errors) {
      setErrors({});
    }
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
            ? "DESC"
            : null,
    }));
  };

  useEffect(() => {
    getLoanNonCash();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterInput]);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Pinjaman Non-tunai (Transfer)"} />
            <Breadcrumb current={"Permohonan Gadai Non-tunai (Transfer)"} />
          </div>
          <div className="ml-auto d-flex align-items-center">
            <div className="total-container">
              <IoIosPaper className="total-icon" />{" "}
              <span style={{ fontWeight: "bold" }}>{totalTransactions}</span>{" "}
              Pinjaman
            </div>
          </div>
        </div>

        <div className="d-flex filter-bar-2">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            value={pageSizeValue}
            handleChange={handleTextInputChange}
          />
          <TextInput
            id={"searchName"}
            label={"No. SBG / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            value={searchNameValue}
            handleChange={handleTextInputChange}
          />
          <CustomDatePicker
            id={"capitalTransaction"}
            label={"Tanggal Pengajuan"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={dateValue}
          />
        </div>

        <CustomTable
          columns={renderLoanNonCashColumns(
            handleProcessButtonClick,
            handleRejectButtonClick
          )}
          scrollX={1400}
          data={loanNonCashList}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
        />
      </div>

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />

      <RejectDialog
        visible={isRejectDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleRejectSave}
        hasCancel
        isDangerButton
        actionButtonText={"Batalkan"}
        title={"Batalkan Proses Pinjaman"}
        handleChange={handleTextInputChange}
        errors={errors}
        reasonValue={reason}
        isStyleBlock
      />
    </div>
  );
};

export default LoanNonCash;
